
import React from 'react';
import { Box, Checkbox, FormControlLabel } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { toggleNotes } from 'redux/actions/inventories/inventShipmentsActions';
import { formatCustomDate } from "helpers/dateTools";
import { formatNumber } from "helpers/getNumberFormats";

export const columnsNationalNotes = (shipmentId) => [
    {
        Header: "Cliente",
        accessor: "customer",
        filterable: true,
        filterMethod: ({ value }, row) => {
            return row.customer.toLowerCase().includes(value);
        },
    },
    {
        Header: "Folio",
        accessor: "folio",
        filterable: true,
        filterMethod: ({ value }, row) => {
            return row.folio.toLowerCase().includes(value);
        },
    },
    {
        Header: "Fecha",
        accessor: "date",
        filterable: true,
        filterMethod: ({ value }, row) => {
            return row.date?.toString().toLowerCase().includes(value);
        },
        Cell: props => props.value !== null ? formatCustomDate(props.value) : null,
    },
    {
        Header: "Kilos",
        accessor: "kg",
        filterable: true,
        filterMethod: ({ value }, row) => {
            return row.kg?.toString().toLowerCase().includes(value);
        },
    },
    {
        Header: "Precio kilo",
        accessor: "unitKgPrice",
        filterable: true,
        filterMethod: ({ value }, row) => {
            return row.unitKgPrice?.toString().toLowerCase().includes(value);
        },
    },
    {
        Header: "Litros",
        accessor: "lt",
        filterable: true,
        filterMethod: ({ value }, row) => {
            return row.lt?.toString().toLowerCase().includes(value);
        },
    },
    {
        Header: "Precio litro",
        accessor: "unitLtPrice",
        filterable: true,
        filterMethod: ({ value }, row) => {
            return row.unitLtPrice?.toString().toLowerCase().includes(value);
        },
    },
    {
        Header: "Tipo",
        accessor: "type",
        filterable: true,
        filterMethod: ({ value }, row) => {
            return row.type.toLowerCase().includes(value);
        },
    },

    {
        Header: "IVA",
        accessor: "iva",
        filterable: true,
        filterMethod: ({ value }, row) => {
            return row.iva?.toString().toLowerCase().includes(value);
        },
        Cell: ({ original }) => (<div>$ {formatNumber(original?.iva)}</div>)
    },
    {
        Header: "Total",
        accessor: "total",
        filterable: true,
        filterMethod: ({ value }, row) => {
            return row.total?.toString().toLowerCase().includes(value);
        },
        Cell: ({ original }) => (<div>$ {formatNumber(original?.total)}</div>)
    },
    {
        Header: "Acciones",
        filterable: false,
        sortable: false,
        Cell: ({ original }) => {
            const dispatch = useDispatch()
            const { inventory } = useSelector(({ inventories }) => inventories)
            const { shipmentsInventory } = inventory?.details;
            const { id } = original

            const shipment = shipmentsInventory.find(s => s.id === shipmentId)
            const isSelected = shipment?.nationalNotesId?.includes(id)
            const handleNotes = () => {
                dispatch(toggleNotes(shipmentId, id));
            };

            return (
                <Box style={{
                    float: 'right'
                }}>
                    {inventory?.status !== "CLOSED" ?
                        <FormControlLabel
                            control={<Checkbox
                                color='success'
                                checked={isSelected}
                                onChange={handleNotes}
                                name='Notes'
                                size='small'
                                sx={{
                                    color: 'rgb(246,110,94)',
                                    '&.Mui-checked': {
                                        color: 'rgb(98, 212, 102)',
                                    },
                                }}
                            />}
                        /> : null
                    }
                </Box>

            );
        },
    },
];